export default "__VITE_ASSET__ATGs6mk7__"